// @flow
import fp from "lodash/fp"
import { createSelector } from "reselect"

import type { Action } from "./actions"
import type { State } from "booking/services/types"

export type Utils = {
  billingDetailsForcedByZooz: boolean, // FIXME: will be removed
  infantsFareSupported: boolean,
}

const DEFAULT_STATE: Utils = {
  billingDetailsForcedByZooz: false,
  infantsFareSupported: false,
}

const utilsReducer = (state: Utils = DEFAULT_STATE, action: Action) => {
  switch (action.type) {
    case "SET_BILLING_DETAILS_FORCED_BY_ZOOZ":
      return fp.set("billingDetailsForcedByZooz", action.payload, state)
    case "SET_INFANTS_FARE_SUPPORTED":
      return fp.set("infantsFareSupported", action.payload, state)
    default:
      return state
  }
}

export default utilsReducer

// Data selectors
// ===
const getUtils = (state: State) => state.reservation.utils

export const getBillingDetailsForcedByZooz: $FlowFixMe = createSelector(
  getUtils,
  utils => utils.billingDetailsForcedByZooz,
)
export const getInfantsFareSupported: $FlowFixMe = createSelector(
  getUtils,
  utils => utils.infantsFareSupported,
)
